import React from 'react';
import {
  PAYPAL_THEME,
  Badge,
  CaptionText,
  IconButton,
  CloseIcon,
  Pill,
  PillTray,
} from '@paypalcorp/pp-react';

import style from './badgeList.less';

const BadgeList = ({ items, onRemove }, ...props) => {
  const badges = items.map((item) => (
    <Pill
      style={{ marginRight: '10px', marginBottom: '8px', marginLeft: '10px' }}
      onDismiss={function () {
        return onRemove(item);
      }}
    >
      {item.primaryText}
    </Pill>
  ));

  return <div role='list'>{badges}</div>;
};

export default BadgeList;
